import { createAsyncTypes } from '../utils';

export const AUTOMATED_REPORTS = createAsyncTypes('AUTOMATED_REPORTS');
export const REMOVE_AUTOMATED_REPORT = createAsyncTypes('REMOVE_AUTOMATED_REPORT');
export const TEMPLATE_ALERTS = createAsyncTypes('TEMPLATE_ALERTS');
export const UPDATE_TEMPLATE_ALERT = createAsyncTypes('UPDATE_TEMPLATE_ALERT');
export const RESEND_TEMPLATE_ALERT = createAsyncTypes('RESEND_TEMPLATE_ALERT');
export const CUSTOM_ALERTS = createAsyncTypes('CUSTOM_ALERTS');
export const UPDATE_CUSTOM_ALERT = createAsyncTypes('UPDATE_CUSTOM_ALERT');
export const REMOVE_CUSTOM_ALERT = createAsyncTypes('REMOVE_CUSTOM_ALERT');
export const RESEND_CUSTOM_ALERT = createAsyncTypes('RESEND_CUSTOM_ALERT');
export const DELIVERY_LOG = createAsyncTypes('DELIVERY_LOG');



// WEBPACK FOOTER //
// ./src/redux/actionTypes/searchAlertsActionTypes.js